import { useStaticQuery, graphql } from "gatsby";
import Link from "./link";
import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import { GatsbyImage } from "gatsby-plugin-image";
import { Container } from "react-bootstrap";

const Navigation = ({ background }) => {
	const data = useStaticQuery(graphql`
		query {
			logoImg: wpMediaItem(title: { eq: "ARC-logo" }) {
				altText
				localFile {
					publicURL
					childImageSharp {
						gatsbyImageData(
							formats: [AUTO, WEBP]
							quality: 100
							transformOptions: { cropFocus: CENTER, fit: CONTAIN }
							layout: CONSTRAINED
							placeholder: TRACED_SVG
						)
					}
				}
			}
		}
	`);
	const bg =
		background ||
		"transparent linear-gradient(108deg, #FBCAEC7D 0%, #FF96DC7A 50%, #F2C8E5 100%) 0% 0% no-repeat";
	const logoImg = data.logoImg.localFile.childImageSharp.gatsbyImageData;

	return (
		<Navbar
			className="py-3"
			style={{
				background: bg,
				opacity: "1",
			}}
			bg="none"
			expand="lg"
		>
			<Container>
				<Navbar.Brand as={Link} to="/">
					<GatsbyImage
						image={logoImg}
						alt={data.logoImg.altText}
						className="nav-logo"
					/>
				</Navbar.Brand>
				<Navbar.Toggle aria-controls="basic-navbar-nav" />
				<Navbar.Collapse id="basic-navbar-nav">
					<Nav className="ms-auto">
						<NavDropdown
							style={{ fontWeight: "600", color: "black" }}
							title="Services"
							id="collasible-nav-dropdown"
						>
							<NavDropdown.Item
								style={{ fontWeight: "600", color: "black" }}
								as={Link}
								to="/services/ghostwriting"
							>
								Ghostwriting
							</NavDropdown.Item>
							<NavDropdown.Item
								style={{ fontWeight: "600", color: "black" }}
								as={Link}
								to="/services/copywriting"
							>
								Copywriting
							</NavDropdown.Item>
							<NavDropdown.Item
								style={{ fontWeight: "600", color: "black" }}
								as={Link}
								to="/services/translation"
							>
								Translation
							</NavDropdown.Item>
							<NavDropdown.Item
								style={{ fontWeight: "600", color: "black" }}
								as={Link}
								to="/services/executive-thought-leadership"
							>
								Executive Thought Leadership
							</NavDropdown.Item>
						</NavDropdown>
						<Nav.Link
							className="ps-lg-6"
							style={{ fontWeight: "600", color: "black" }}
							as={Link}
							to="/copy-strategy-packages"
						>
							Packages
						</Nav.Link>
						<Nav.Link
							className="ps-lg-6"
							style={{ fontWeight: "600", color: "black" }}
							as={Link}
							to="/about"
						>
							About
						</Nav.Link>
						<Nav.Link
							className="ps-lg-6"
							style={{ fontWeight: "600", color: "black" }}
							as={Link}
							to="/blog"
						>
							Blog
						</Nav.Link>
						<Nav.Link
							className="ps-lg-6"
							style={{ fontWeight: "600", color: "black" }}
							as={Link}
							to="/contact"
						>
							Contact
						</Nav.Link>
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	);
};

export default Navigation;
